import React from "react";
import PropTypes from "prop-types";
import Expandable from "web/react/components/expandable/expandable";
import analytics from "web/script/analytics/analytics";
import style from "./product-description-price-history-bullet.css";

function ProductDescriptionPriceHistoryBullet({
    className,
    priceHistoryBullet,
    productAreaAccordions,
}) {
    return productAreaAccordions ? (
        <div className={className}>
            <Expandable
                renderLabel={() => <h4>{"Price History"}</h4>} // TODO: i18n
                onClick={(isOpen) => {
                    if (!isOpen) {
                        analytics.event("product area", "click", "open-priceHistory");
                    }
                }}
            >
                <p>
                    {priceHistoryBullet}
                    {" " /* we need a single whitespace here */}
                    <a className={style.anchor} href="#price-history">
                        {
                            "See price and stock history." // TODO: i18n
                        }
                    </a>
                </p>
            </Expandable>
        </div>
    ) : (
        <div className={className}>
            <h4 className={style.title}>
                {
                    "Price History" // TODO: i18n
                }
            </h4>
            <p>
                {priceHistoryBullet}
                {" " /* we need a single whitespace here */}
                <a className={style.anchor} href="#price-history">
                    {
                        "See price and stock history." // TODO: i18n
                    }
                </a>
            </p>
        </div>
    );
}

ProductDescriptionPriceHistoryBullet.propTypes = {
    className: PropTypes.string,
    priceHistoryBullet: PropTypes.string.isRequired,
    productAreaAccordions: PropTypes.bool,
};

export default ProductDescriptionPriceHistoryBullet;
